import * as SQLite from 'expo-sqlite';
import { Database } from './database';
import uuid from 'react-native-uuid';

export class EngineerReportDatabase extends Database {
  TABLE_NAME = "EngineerReports";
  TABLE_NAME_TIMESHEETS = "EngineerReportTimesheets";
  TABLE_NAME_PARTS = "EngineerReportParts";

  initialise() : Promise<void> {
    return new Promise((resolve, reject) => {
      var sql = `CREATE TABLE IF NOT EXISTS EngineerReports ( 
        id TEXT PRIMARY KEY,
        engineerId TEXT,
        jobId TEXT,
        worksCarriedOut TEXT,
        furtherWorks TEXT,
        jobCompleted INT,
        clientName TEXT,
        clientSignature TEXT,
        customerPoNumber TEXT,
        toBeSynced INT
      )`;

      var sqlTimesheets = `CREATE TABLE IF NOT EXISTS EngineerReportTimesheets ( 
        id TEXT PRIMARY KEY,
        day TEXT,
        toSite TEXT,
        arrived TEXT,
        depart TEXT,
        home TEXT,
        hours TEXT,
        hoursHalf TEXT,
        hoursDouble TEXT,
        engineerReportId
      )`;

      var sqlParts = `CREATE TABLE IF NOT EXISTS EngineerReportParts ( 
        id TEXT PRIMARY KEY,
        partId INT,
        engineerReportId TEXT
      )`;

      Database.getDb().transaction((tx) => {
        tx.executeSql(sql);
        tx.executeSql(sqlTimesheets);
        tx.executeSql(sqlParts);
      }, (error) => {
        console.log(error)
        reject();
      }, () => {
        resolve();
      })
    });
  }

  getById(engineerReportId) : Promise<any> {
    return new Promise((resolve, reject) => {
      var engineerReport = null;
      Database.getDb().transaction((tx) => {
        var sql = `
          SELECT * FROM ${this.TABLE_NAME} WHERE id = ?
        `;

        tx.executeSql(sql, [engineerReportId], (_, { rows: { _array } }) => {
          if (_array.length > 0) {
            engineerReport = _array[0];

            // Load timesheets
            engineerReport.timesheets = [];
            sql = `SELECT * FROM ${this.TABLE_NAME_TIMESHEETS} WHERE engineerReportId = ?`;
            tx.executeSql(sql, [engineerReportId], (_, { rows: { _array } }) => {
              if (_array.length > 0) {
                engineerReport.timesheets = _array;
              }
            });

            // Load parts
            engineerReport.parts = [];
            sql = `SELECT * FROM ${this.TABLE_NAME_PARTS} WHERE engineerReportId = ?`;
            tx.executeSql(sql, [engineerReportId], (_, { rows: { _array } }) => {
              if (_array.length > 0) {
                engineerReport.parts = _array;
              }
            });
          }
        });
      }, (error) => {
        console.log(error);
        reject();
      }, () => {
        resolve(engineerReport);
      })
    })
  }

  addEngineerReport(engineerReportId: any, engineerId: any, jobId: any, worksCarriedOut: any, furtherWorks: any, 
    jobCompleted: any, clientName: any, clientSignature: any, customerPoNumber: any, timesheets: any, parts: any) : Promise<string> {

    if (engineerReportId == null) {
      engineerReportId = uuid.v4();
    }

    return new Promise((resolve, reject) => {
      Database.getDb().transaction((tx) => {
        var sql = `
          INSERT OR REPLACE INTO ${this.TABLE_NAME} (id, engineerId, jobId, worksCarriedOut, furtherWorks, jobCompleted, clientName, clientSignature, customerPoNumber, toBeSynced)
          VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, 1)
        `

        tx.executeSql(sql, [engineerReportId, engineerId, jobId, worksCarriedOut, furtherWorks, jobCompleted, clientName, clientSignature, customerPoNumber]);

        // //update the job
        // console.log("Job id " + jobId);
        // console.log("Engineer report id " + engineerReportId);
        // var sql = `
        // UPDATE Jobs  
        // SET engineerReportId = ?, toBeSynced = 1 
        // WHERE id = ?
        // `
        // tx.executeSql(sql, [engineerReportId,  jobId]);
        // console.log("UPDATEd Job");
        

        //Insert timesheets
        sql = `
          INSERT OR REPLACE INTO ${this.TABLE_NAME_TIMESHEETS} (id, day, toSite, arrived, depart, home, hours, hoursHalf, hoursDouble, engineerReportId)
          VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        `;
      
        for (let timesheet of timesheets) {
          var id = timesheet.id;
          if (id == null) { id = uuid.v4() }
          tx.executeSql(sql, [
            id, timesheet.day, timesheet.toSite, timesheet.arrived, timesheet.depart, 
            timesheet.home, timesheet.hours, timesheet.hoursHalf, timesheet.hoursDouble, engineerReportId
          ]);
        }

        sql = `DELETE FROM ${this.TABLE_NAME_PARTS} WHERE engineerReportId = ?`;
        tx.executeSql(sql, [engineerReportId]);

        //Insert parts
        sql = `
          INSERT OR REPLACE INTO ${this.TABLE_NAME_PARTS} (id, partId, engineerReportId)
          VALUES (?, ?, ?)
        `;

        for (let part of parts) {
          var id = uuid.v4();
          tx.executeSql(sql, [id, part.id, engineerReportId]);
        };


        



      }, (error) => {
        console.log(error);
        reject();
      }, () => {
        resolve(engineerReportId.toString());
      });
    });
  }

  getForSync() : Promise<any> {
    return new Promise((resolve, reject) => {
      var data = [];
      Database.getDb().transaction((tx) => {
        var sql = `
          SELECT * FROM ${this.TABLE_NAME} WHERE toBeSynced = 1
        `;

        tx.executeSql(sql, [], (_, { rows: { _array } }) => {
          data = _array;

          var sqlTimesheets = `SELECT * FROM ${this.TABLE_NAME_TIMESHEETS} WHERE engineerReportId = ?`;
          var sqlParts = `SELECT * FROM ${this.TABLE_NAME_PARTS} WHERE engineerReportId = ?`;
          for (let engineerReport of data) {
            tx.executeSql(sqlTimesheets, [engineerReport.id], (_, { rows: { _array } }) => {
              engineerReport.timesheets = _array;
            });

            tx.executeSql(sqlParts, [engineerReport.id], (_, { rows: { _array } }) => {
              engineerReport.parts = _array;
            });
          }
        });
      }, (error) => {
        console.log(error);
        reject();
      }, () => {
        console.log("ERSTR to Sync");
        console.log(data);
        resolve(data);
      })
    });
  }

  updateEngineerReportToBeSynced(id, toBeSynced) : Promise<boolean> {
    return new Promise((resolve, reject) => {
      Database.getDb().transaction((tx) => {
        var sql = `
          UPDATE ${this.TABLE_NAME} SET toBeSynced = ? WHERE id = ?
        `;

        tx.executeSql(sql, [toBeSynced, id], (_, { rows: { _array } }) => {
          
        });
      }, (error) => {
        console.log(error);
        reject();
      }, () => {
        resolve(true);
      })
    });
  }

  insertOrUpdateList(entities: any) : Promise<void> {
    return new Promise((resolve, reject) => {
      Database.getDb().transaction((tx) => {
        for (let entity of entities) {
          tx.executeSql(`DELETE FROM ${this.TABLE_NAME_TIMESHEETS} WHERE engineerReportId = ?`, [entity.id]);
          tx.executeSql(`DELETE FROM ${this.TABLE_NAME_PARTS} WHERE engineerReportId = ?`, [entity.id]);
          tx.executeSql(`DELETE FROM ${this.TABLE_NAME} WHERE id = ?`, [entity.id]);

          if (entity.isDeleted || entity.isDeleted == 1) {
            continue;
          }


          var sql = `
            INSERT OR REPLACE INTO ${this.TABLE_NAME} (id, engineerId, jobId, worksCarriedOut, furtherWorks, jobCompleted, clientName, clientSignature, customerPoNumber, toBeSynced)
            VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, 0)
          `

          tx.executeSql(sql, [
            entity.id, entity.engineerId, entity.jobId, entity.worksCarriedOut, entity.furtherWorks, entity.jobCompleted ? 1 : 0,
            entity.clientName, entity.clientSignature, entity.customerPoNumber
          ]);

          for (let timesheet of entity.timesheets) {
            tx.executeSql(`INSERT INTO ${this.TABLE_NAME_TIMESHEETS} (id, day, toSite, arrived, depart, home, hours, hoursHalf, hoursDouble, engineerReportId) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)`, 
            [timesheet.id, timesheet.day, timesheet.toSite, timesheet.arrived, timesheet.depart, timesheet.home, timesheet.hours, timesheet.hoursHalf, timesheet.hoursDouble, entity.id]);
          }

          for (let part of entity.parts) {
            tx.executeSql(`INSERT INTO ${this.TABLE_NAME_PARTS} (id, partId, engineerReportId) VALUES (?, ?, ?)`, 
            [part.id, part.partId, entity.id]);
          }
        }
      }, (error) => {
        console.log(error);
        reject();
      }, () => {
        resolve();
      })
    })
  }
}